module.exports = __webpack_public_path__ + "img/home-logo.08782051.png";